export const REQUEST_DELAY = 1100;
export const IS_VALID_DELAY = 300;
export const IS_FETCHING_VEHICLE_DELAY = 3200;
export const DEFAULT_FADE_TIME = 1000;
export const RECALCULATE_DELAY = 3000;
export const CLOSE_AFTER_SUCCESS_SUBMIT_DELAY = 3000;
export const CANCEL_ANIMATION_DELAY = 2000;
export const ADDENDUM_STEP_DELAY = 300;
export const STEP_ANIMATION_DURATION_MS = 500;
